import { ServerConfig } from "@/config/config";

export function getFileUrl(token:string):string {
	return `${ServerConfig.host}/files/${token}`;
}

export function getAuthFileUrl(token:string):string {
	return `${ServerConfig.auth}/files/${token}`;
}